import React, { useState, useEffect } from 'react'
import Sidebar from './Sidebar/Sidebar'
import Home from './Sidebar/Home'
import Conductores from './Sidebar/Conductores'
import ViajesEnCurso from './Sidebar/ViajesEnCurso'
import ViajesFinalizados from './Sidebar/ViajesFinalizados'
import Pasajeros from './Sidebar/Pasajeros'
import Mapa from './Sidebar/Mapa'
import NavBar from '../components/NavBar/NavBar'

import useCurrentTrips from '../hooks/useCurrentTrips'
import AlertModal from './Sidebar/CurrentTrips/AlertModal'

const componentMap = {
	Home,
	Conductores,
	ViajesEnCurso,
	ViajesFinalizados,
	Pasajeros,
	Mapa
};

const Dashboard = () => {
	const [currentPage, setCurrentPage] = useState('Home')
	const [mapKey, setMapKey] = useState(0)

	const { trips, getTrips, monitoring, panicAlert } = useCurrentTrips()
	const [showModal, setShowModal] = useState(false)

	useEffect(() => {
		const intervalId = setInterval(() => { getTrips() }, 5000)
		return () => clearInterval(intervalId)
	}, [trips])

	useEffect(() => {
		if (monitoring || panicAlert) setShowModal(true)
		else setShowModal(false)
	}, [monitoring, panicAlert])

	return (
		<>
			<div className='h-0'>
				<NavBar setCurrentPage={setCurrentPage} />
			</div>
			<div className='flex'>
				<div className='xl:w-sb lg:w-0 md:w-0 sm:w-0 xs:w-0 2xs:w-0'>
					<Sidebar setCurrentPage={setCurrentPage} setMapKey={setMapKey} />
				</div>
				<div className='flex-1 2xs:hidden overflow-x-auto bg-bgDash md:block min-h-screen xl:mt-0 2xs:mt-30'>
					{
						componentMap[currentPage]
							? React.createElement(
								componentMap[currentPage],
								{ trips: currentPage === 'ViajesEnCurso' && trips }
							)
							: null
					}
					<AlertModal
						open={showModal}
						onClose={() => setShowModal(false)}
						panic={panicAlert}
					/>
				</div>
				<h1 className='2xs:block md:hidden mt-32 text-2xl font-bold text-center'>Página no disponible para dispositivos móviles. Por favor,
					accede desde una tablet o una pantalla más grande para disfrutar de la experiencia completa.</h1>
			</div>
		</>
	)
}

export default Dashboard